import {
  ListItemButton,
} from "@mui/material";

import { SearchablePopoverItemProps } from "./searchable-popover.types";

export const SearchablePopoverItem = <T,>({
  item,
  selected,
  renderItem,
  onClick,
}: SearchablePopoverItemProps<T>) => {
  return (
    <ListItemButton
      selected={selected}
      onClick={() => onClick(item)}
      sx={{
        px: 2,
        py: 1,
      }}
    >
      {renderItem(item, selected)}
    </ListItemButton>
  );
};